<style scoped lang="scss">
    .cpn-receiptor {
        padding-bottom: 40px;
    }

    .receiptor-header {
        margin-top: 40px;
        padding: 12px 30px;

        .l {
            flex: 1;
            font-size: 16px;
            text-align: left;

            button {
                width: 160px;
                height: 40px;
                line-height: 40px;
                color: white;
                background: #f9b451;
            }
        }

        .date {
            width: 280px;
            padding-right: 10px;

        }

        .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner {
            width: 280px;
        }
    }

    .receiptor-items {
        margin-top: 30px;
        background: white;
        font-size: 14px;

        .header {
            height: 40px;
            line-height: 40px;
            padding-left: 30px;
            background: #fafafa;
            border: 1px solid #f2f2f2;
        }
    }

    .pagination {
        padding-top: 40px;
    }


    ::v-deep .p-l-20 {
        padding-left: 20px;
    }

    .avatar-uploader ::v-deep .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader ::v-deep .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        width: 220px;
        height: 150px;

        i {
            font-size: 28px;
            color: #8c939d;
            padding-top: 30px;
            width: 220px;
            height: 50px;
            line-height: 50px;
            text-align: center;
        }
    }

    .avatar {
        width: 220px;
        height: 150px;
        display: block;
    }

    ::v-deep .el-dialog {
        width: 80%;
        max-width: 700px;
    }

    ::v-deep .el-dialog__body {
        padding: 0 20px;
    }
</style>
<template>
    <div class="cpn-receiptor">
        <div class="receiptor-header card rowflex">
            <div class="l">
                <button @click="addresseeEditFormVisible = true" v-if="!isCurAssignReceiptor"><i class="el-icon-plus"></i> 添加收件人</button>
            </div>
            <div class="search">
                <el-input placeholder="请输入姓名或手机号" v-model="keywords" size="small">
                    <el-button slot="append" @click="search">搜索</el-button>
                </el-input>
            </div>
        </div>
        <div>
            <div class="card receiptor-items">
                <el-table
                    :data="list"
                    stripe
                    style="width: 100%">
                    <el-table-column
                        class-name="p-l-20"
                        label="姓名"
                        width="150">
                        <template slot-scope="scope">{{scope.row.addressee.name}}</template>
                    </el-table-column>
                    <el-table-column
                        label="电话"
                        width="180">
                        <template slot-scope="scope">{{scope.row.addressee.tel}}</template>
                    </el-table-column>

                    <el-table-column
                        label="地址"
                        show-overflow-tooltip>
                        <template slot-scope="scope">{{scope.row.addressee.detail}}</template>
                    </el-table-column>
                    <el-table-column
                        label="身份证号码"
                        width="220">
                        <template slot-scope="scope">{{scope.row.addressee.idCardNo}}</template>
                    </el-table-column>
                    <el-table-column
                        label="身份证照片"
                        width="90">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.addressee && scope.row.addressee.idCardBackImageUrl && scope.row.addressee.idCardFrontImageUrl" type="success">已上传</el-tag>
                            <el-tag v-else type="info">未上传</el-tag>
                        </template>
                    </el-table-column>
                    <!--<el-table-column
                        prop="remarks"
                        label="备注"
                        width="210"
                        show-overflow-tooltip>
                        <template slot-scope="scope">{{scope.row.addressee.detail}}</template>
                    </el-table-column>-->
                    <el-table-column
                        label="操作"
                        width="150">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" content="修改" placement="top">
                                <el-button @click="edit(scope.row)" type="" icon="el-icon-edit" circle
                                           size="small"></el-button>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="删除" placement="top">
                                <el-button type="danger" icon="el-icon-delete" circle size="small"
                                           v-if="!isChoiseReceiptor && !isCurAssignReceiptor" @click="del(scope.row)"></el-button>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="选择" placement="top">
                                <el-button type="success" icon="el-icon-check" circle size="small"
                                           v-if="isChoiseReceiptor && !isCurAssignReceiptor" @click="choiseReceiptor(scope.row)"></el-button>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="pagination" v-if="datas.totalCount>filter.size">
            <el-pagination
                background
                layout="prev, pager, next"
                @current-change="changePage"
                :page-size="filter.size"
                :total="datas.totalCount">
            </el-pagination>
        </div>

        <el-dialog append-to-body top="5vh" title="添加/修改收件人" custom-class="editDialog" :visible.sync="addresseeEditFormVisible"
                   :close-on-click-modal="false" @closed="editLoading=false">

            <el-form :model="editModel" ref="editForm" v-loading="editLoading" :rules="rules" label-width="120px">
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="editModel.name" placeholder="请输入姓名" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="手机号码" prop="tel">
                    <el-input v-model="editModel.tel" placeholder="请输入手机号码" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="地区" prop="area">
                    <el-cascader
                        :options="areas"
                        :props="{
                            label:'name',
                            value:'code',
                            children:'area'
                        }"
                        v-model="selectionAreas"
                        @change="areaChange">
                    </el-cascader>
                </el-form-item>
                <el-form-item label="街道地址" prop="detail">
                    <el-input v-model="editModel.detail" autocomplete="off"
                              placeholder="请输入街道地址，不含省、市、区县"></el-input>
                </el-form-item>
                <!--<el-form-item label="完整地址" prop="fullAddress">
                    <el-input v-model="editModel.fullAddress" autocomplete="off"
                              placeholder="您可以先输入完整地址，系统自动填写地区和详细地址"></el-input>
                </el-form-item>-->
                <el-form-item label="身份证号码" prop="idCardNo">
                    <el-input v-model="editModel.idCardNo" @change="getIdCardImage" placeholder="请输入身份证号码(非必填)" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="上传身份证">
                    <div v-loading="idCardLoading">
                        <el-row :gutter="20" style="margin: 0">
                            <el-col :span="12" style="padding: 0">
                                <el-form-item label="" prop="idCardFrontImageUrl">
                                    <el-upload
                                        class="avatar-uploader"
                                        accept="image/jpeg,image/gif,image/png"
                                        :action="uploadUrl"
                                        :headers="uploadHeaders"
                                        :show-file-list="false"
                                        :on-success="idCardFrontImageSuccess"
                                        :before-upload="beforeAvatarUpload">
                                        <img v-if="editModel.idCardFrontImageUrl" :src="editModel.idCardFrontImageUrl"
                                             class="avatar">
                                        <div v-else class="avatar-uploader-icon">
                                            <i class="el-icon-plus"></i><br/>
                                            人像面
                                        </div>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="" prop="idCardBackImageUrl">
                                    <el-upload
                                        class="avatar-uploader"
                                        accept="image/jpeg,image/gif,image/png"
                                        :action="uploadUrl"
                                        :headers="uploadHeaders"
                                        :show-file-list="false"
                                        :on-success="idCardBackImageSuccess"
                                        :before-upload="beforeAvatarUpload">
                                        <img v-if="editModel.idCardBackImageUrl" :src="editModel.idCardBackImageUrl"
                                             class="avatar">
                                        <div v-else class="avatar-uploader-icon">
                                            <i class="el-icon-plus"></i><br/>
                                            国徽面
                                        </div>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelForm('editForm')">取 消</el-button>
                <el-button type="primary" @click="submitForm('editForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    // todo 粘贴详细地址自动选择省市县
    import areaData from '@/js/area.js'

    export default {
        name: 'cpnReceiptor',
        props: {
            'isChoiseReceiptor': {
                default: false,
                type: Boolean
            },
            isAssignReceiptor: {
                default: false,
                type: Boolean
            },
            assignItem: {
                default: null
            }
        },
        data () {
            return {
                editLoading: false,
                idCardLoading:false,
                addresseeEditFormVisible: false,
                uploadUrl: window.baseUrl + window.consts.apis.uploadFile,
                keywords:'',
                memberId: 0,
                //取消表单的时候，清空数据
                emptyModel:{
                    id: 0,
                    name: '',
                    tel: '',
                    province: '',
                    city: '',
                    area: '',
                    detail: '',
                    idCardNo: '',
                    idCardFrontImageUrl: '',
                    idCardBackImageUrl: ''
                },
                editModel: {
                    id: 0,
                    name: '',
                    tel: '',
                    province: '',
                    city: '',
                    area: '',
                    detail: '',
                    idCardNo: '',
                    idCardFrontImageUrl: '',
                    idCardBackImageUrl: ''
                },
                areas: [],
                selectionAreas: [],
                list: [],
                datas: {
                    items: [],
                    totalCount: 0
                },
                rules: {
                    name: [
                        { required: true, message: '请输入收件人姓名', trigger: 'blur' },
                    ],
                    tel: [
                        { required: true, message: '请输入联系电话', trigger: 'blur' }
                        /*{ pattern: /^(\d{11})|(\d{3}-\d{8})|(\d{4}-\d{7})$/, message: '联系电话只能是11位数字，或：区号-号码' }*/
                    ],
                    area: [
                        { required: true, message: '请选择地区', trigger: 'change' },
                    ],
                    detail: [
                        { required: true, message: '请输入详细地址', trigger: 'blur' }
                        /*{
                            validator: (rule, value, callback) => {

                                if (value === areaData.getAreaNames(this.selectionAreas).join('')) {
                                    callback(new Error('请输入详细地址'))
                                } else {
                                    callback()
                                }
                            }, trigger: 'blur'
                        },*/
                    ],
                    idCardNo: [
                        { required: false, message: '请输入收件人身份证号码', trigger: 'blur' },
                        //{ pattern: /^(\d{14}|\d{17})[0-9Xx]$/, message: '身份证号码格式有误' }
                        { pattern: /^([1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx])|([1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2})$/, message: '身份证号码格式有误', trigger: 'blur' }
                    ]
                    /*,
                    idCardFrontImageUrl: [
                        { required: true, message: '请上传身份证人像面', trigger: 'blur' },
                    ],
                    idCardBackImageUrl: [
                        { required: true, message: '请上传身份证国徽面', trigger: 'blur' },
                    ],*/
                },
                filter: {
                    keywords:'',
                    page: 1,
                    size: 5
                },
                isCurAssignReceiptor: this.isAssignReceiptor
            }
        },
        async mounted () {
            await areaData.getAreasData().then(res => {
                this.areas = res
            })
            this.getList()
        },
        watch: {
            filter: {
                deep: true,
                handler: function (newVal, oldVal) {
                    //console.log('filter change')
                    this.getList()
                }
            },
            isAssignReceiptor(val) {
                this.isCurAssignReceiptor = val
            },
            assignItem(val) {
               this.assignItem = val
               this.getList()
            }
            /*keywords(v){
                console.log('keywords',v)
            }*/
        },
        methods: {
            getIdCardImage(idNo){
                if(!idNo) return;
                this.idCardLoading=true;
                this.$axios.post(window.consts.apis.getAddresseeByIDNO+'?idCard='+idNo).then(r=>{
                    this.idCardLoading=false;
                    if(r.success){
                        this.editModel.idCardFrontImageUrl = r.result.idCardFrontImageUrl;
                        this.editModel.idCardBackImageUrl = r.result.idCardBackImageUrl;
                    }
                }).catch(e=>{
                    this.idCardLoading=false;
                })
            },
            search(){
                this.filter.page=1;
                this.filter.keywords = this.keywords;
            },
            getList (isAssign) {
                if (this.isCurAssignReceiptor) {
                    this.filter.keywords = this.assignItem.addressee && this.assignItem.addressee.tel
                }
                this.$axios.get(window.consts.apis.getAddresses, { params: this.filter }).then(r => {
                    if (r.success) {
                        this.datas = r.result
                        this.list = r.result.items
                        // 判断是指定收件人时
                        this.$nextTick(function() {
                            if (this.isCurAssignReceiptor && !isAssign) {
                                this.edit(this.assignItem)
                            }
                        })
                    }
                }).catch(e => {

                })
            },
            changePage (page) {
                this.filter.page = page
            },
            del (item) {
                this.$confirm('确定要删除吗？', '', {
                    type: 'warning'
                }).then(() => {
                    this.$axios.delete(window.consts.apis.deleteAddressee, { params: { id: item.id } }).then(r => {
                        if (r.success) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            })
                            if (this.filter.page === 1) {
                                this.getList()
                            } else {
                                this.filter.page = 1
                            }
                        } else {
                            this.$alert(r.error.message, '')
                        }
                    })

                })
            },
            edit (item) {
                console.log(this.list)
                let row = this.list.filter(x=>x.id === item.id)[0];
                this.editModel = Object.assign({},row.addressee);
                this.editModel.id = row.id;
                this.memberId = item.memberId;
                this.selectionAreas = [this.editModel.province, this.editModel.city, this.editModel.area];
                this.addresseeEditFormVisible=true;
            },
            cancelForm(formName){
                this.$refs[formName].resetFields();
                this.memberId = 0;
                this.editModel = Object.assign({}, this.emptyModel);
                this.selectionAreas=[];
                this.addresseeEditFormVisible = false;
            },
            submitForm (formName) {
                let that = this
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        that.editLoading = true
                        this.$axios.post(window.consts.apis.saveAddressee, {
                            id: this.editModel.id,
                            memberId: this.memberId,
                            addressee: this.editModel
                        }).then(r => {
                            this.editLoading = false
                            if (r.success) {
                                this.$refs[formName].resetFields()
                                this.$notify({
                                    title: '',
                                    message: this.editModel.id>0?'修改成功':'添加成功',
                                    type: 'success',
                                    duration: 2000,
                                    onClose: (rt => {
                                        // 指定了收件人时，保存成功需要回调
                                        if (this.isCurAssignReceiptor) {
                                            this.assignCallback(true)
                                        }
                                        this.addresseeEditFormVisible = false;
                                        this.getList(true);
                                        this.cancelForm("editForm");
                                    })
                                })
                            }
                        }).catch(e => {
                            this.editLoading = false
                        })
                    } else {
                        console.log('error submit!!')
                        return false
                    }
                })
            },
            areaChange (arr) {
                this.selectionAreas = arr
                if (arr.length > 0) {
                    this.editModel.province = arr[0]
                    this.editModel.city = arr[1]
                    this.editModel.area = arr[2]
                    // this.editModel.detail = areaData.getAreaNames(arr).join('')
                    this.editModel.detail = ''
                } else {
                    this.editModel.province = ''
                    this.editModel.city = ''
                    this.editModel.area = ''
                    this.editModel.detail = ''
                }
            },
            idCardFrontImageSuccess (res, file) {
                this.editModel.idCardFrontImageUrl = res.result.fileUrl
            },
            idCardBackImageSuccess (res, file) {
                this.editModel.idCardBackImageUrl = res.result.fileUrl
            },
            beforeAvatarUpload (file) {
                const isLt2M = file.size / 1024 / 1024 < 2
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!')
                    return false
                }
                return true
            },
            // 选择后通知父组件
            choiseReceiptor (item) {
                this.$emit('choisedReceiptor', item)
            },
            // 指定收件人时，保存成功的回调通知父组件
            assignCallback (val) {
                this.$emit('assignCallback', val)
            }
        }

    }
</script>


